'use client'

import { getAuthConfig } from '../config'

import { AuthProvider } from '@/features/auth/contexts/AuthContext'

interface AuthLayoutProps {
  children: React.ReactNode
}

export function AuthLayout({ children }: AuthLayoutProps) {
  const config = getAuthConfig()

  return (
    <AuthProvider config={config}>
      <div className="relative flex min-h-svh flex-col items-center justify-center overflow-hidden bg-brand-dark px-4 py-8 sm:p-8">
        {/* glow institucional — coerente com a landing */}
        <div className="pointer-events-none absolute inset-0 opacity-60">
          <div className="absolute -top-24 -left-24 size-96 rounded-full bg-brand-purple opacity-50 blur-3xl" />
          <div className="absolute -right-32 top-1/3 size-[28rem] rounded-full bg-brand-blue opacity-60 blur-3xl" />
        </div>

        <div className="relative z-10 flex w-full flex-col items-center">
          {children}
        </div>
      </div>
    </AuthProvider>
  )
}
